module.exports = __webpack_public_path__ + "media/images/icon-vk-cfc2776a3048833d80d78d95a2f258f4.png";